const postFeatureFlags = {
  toastr: 'Tenant atualizada',
  toastr1: ' foi atualizada com sucesso'
};

export default postFeatureFlags;
